import { render, staticRenderFns } from "./treasureWareHouse.vue?vue&type=template&id=74359224&scoped=true"
import script from "./treasureWareHouse.vue?vue&type=script&lang=js"
export * from "./treasureWareHouse.vue?vue&type=script&lang=js"
import style0 from "./treasureWareHouse.vue?vue&type=style&index=0&id=74359224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74359224",
  null
  
)

export default component.exports